<template>
  <div class="major-structure" @click.stop>
    <!-- 背景图 -->
    <img class="bg-img" src="@/assets/imgs/FormATeam/component/bg.png" alt="Dialog Background" />

    <div class="content-wrapper">
      <!-- 动态标题 -->
      <div class="header-title">
        <img :src="require(`@/assets/imgs/FormATeam/component/tit${currentType}.png`)" alt="Title" />
      </div>

      <div class="detailed-info">
        <!-- 1. 创建队伍 -->
        <div class="info-block" v-if="currentType === 1">
          <div class="input-group">
            <span class="label">队伍名称：</span>
            <input type="text" v-model.trim="teamName" placeholder="请输入队伍名称" maxlength="16" />
          </div>
          <div class="action-bar">
            <button class="btn-primary" @click="handleFormTeam(4)">创建队伍</button>
          </div>
        </div>

        <!-- 2. 加入队伍 -->
        <div class="info-block" v-if="currentType === 2">
          <div class="input-group">
            <span class="label">入队码：</span>
            <input type="text" v-model.trim="teamName" placeholder="请输入好友分享的入队码" />
          </div>
          <div class="action-bar">
            <button class="btn-primary" @click="handleFormTeam(5)">加入队伍</button>
          </div>
        </div>

        <!-- 3. 规则说明 -->
        <div class="info-block" v-if="currentType === 3">
          <div class="rules-container">
            <div class="rule-item text-center highlight-box">
              <span class="label-gold">活动时间：</span>
              <span class="text-danger font-bold">2026年8月19日 00:00:00 ～ 2026年9月13日 23:59:59</span>
            </div>
            <div class="rule-item text-center">活动无单独组队期，活动全程开放组队、加入队伍与积分累计功能。</div>
            <div class="rule-item">1.同一账号仅可创建 1 支队伍，或加入 1 支队伍，不可同时创建 + 加入多支队伍。</div>
            <div class="rule-item">2.玩家可在活动页面创建队伍，生成唯一入队码，或通过好友分享入队码邀请他人加入。</div>
            <div class="rule-item">3.玩家可通过输入好友分享的入队码，直接加入对应队伍。</div>
            <div class="rule-item">4. 队伍约束：</div>
            <div class="rule-item indent">（1）玩家成功加入任意一支队伍后，全程不可主动退出队伍；</div>
            <div class="rule-item indent">（2）队长全程不可踢出队伍内任意成员；</div>
            <div class="rule-item">5. 单支队伍人数上限：2 人。</div>

            <div class="rule-title">积分规则：</div>
            <div class="rule-item indent">1.积分换算比例：1 元人民币=1金龙元宝 = 1 积分。</div>
            <div class="rule-item indent">2.积分统计范围：活动期间，玩家在官网商城的所有的充值，均累计为个人积分，同时等额计入队伍总积分。</div>
            <div class="rule-item indent">3.队伍总积分：队伍内所有成员个人积分之和，用于解锁队伍阶梯奖励；</div>
            <div class="rule-item indent">4.积分统计时间：仅统计2026 年8月 19日 00:00:00 ～ 2026 年 9 月 13 日 23:59:59 期间的有效充值。
            </div>

            <div class="rule-title">奖励规则：</div>
            <div class="rule-item indent">1.奖励解锁依据：以队伍总积分为标准，达成对应积分门槛，即可解锁对应队伍奖励。</div>
            <div class="rule-item indent">
              <!-- 2. 奖励领取资格：<span class="text-danger font-bold">队伍的成员消费到达 X 积分即可领取本队伍已解锁的全部阶梯奖励。</span> -->
               2.队伍奖励可叠加领取。
            </div>
            <div class="rule-item indent">3. 队伍奖励请在活动结束前领取，逾期作废。</div>
          </div>
          <div class="action-bar img-actions">
            <img class="btn-img" @click="handleCancel" src="@/assets/imgs/FormATeam/component/cancel.png" alt="取消" />
          </div>
        </div>

        <!-- 4. 二次确认 - 创建队伍 -->
        <div class="info-block" v-if="currentType === 4">
          <p class="dialog-hint">创建队伍后无法退出，请确定！</p>
          <div class="action-bar">
            <button :class="['btn-primary', { 'btn-disabled': countDownNum > 0 }]" :disabled="countDownNum > 0"
              @click="handleConfirm('Create')">
              <span v-if="countDownNum > 0">确定创建 ({{ countDownNum }}s)</span>
              <span v-else>确定创建</span>
            </button>
            <button class="btn-secondary" @click="handleCancel">取消创建</button>
          </div>
        </div>

        <!-- 5. 二次确认 - 加入队伍 -->
        <div class="info-block" v-if="currentType === 5">
          <p class="dialog-hint">加入队伍后无法退出，请确定！</p>
          <div class="action-bar">
            <button :class="['btn-primary', { 'btn-disabled': countDownNum > 0 }]" :disabled="countDownNum > 0"
              @click="handleConfirm('Join')">
              <span v-if="countDownNum > 0">确定加入 ({{ countDownNum }}s)</span>
              <span v-else>确定加入</span>
            </button>
            <button class="btn-secondary" @click="handleCancel">取消加入</button>
          </div>
        </div>

        <!-- 6. 隐藏兑换 -->
        <div class="info-block" v-if="currentType === 6">
          <p class="dialog-hint exchange-hint">确定使用兑换吗？</p>
          <div class="action-bar img-actions">
            <img class="btn-img" @click="handleCancel" src="@/assets/imgs/Qixi/component/cancel.png" alt="取消" />
            <img class="btn-img" @click="handleConfirm('Exchange')" src="@/assets/imgs/Qixi/component/confirm.png"
              alt="确认" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TeamModal",
  props: {
    close: {
      type: Function,
      required: true,
    },
    Confirm: {
      type: Function,
      required: true,
    },
    type: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      currentType: 1,
      teamName: "",
      countDownNum: 5,
      timer: null,
    };
  },
  watch: {
    type: {
      immediate: true,
      handler(val) {
        this.currentType = val;
      },
    },
  },
  beforeDestroy() {
    this.clearCountdownTimer();
  },
  methods: {
    // 关闭弹窗
    handleCancel() {
      this.clearCountdownTimer();
      this.close();
    },

    // 提交确定逻辑
    handleConfirm(actionType) {
      this.Confirm({
        type: actionType,
        TeamName: this.teamName,
      });
    },

    // 触发倒计时逻辑
    handleFormTeam(targetType) {
      if (!this.teamName) {
        return this.$message.error("请先输入名称或入队码！");
      }

      this.currentType = targetType;
      this.startCountdown();
    },

    // 倒计时控制
    startCountdown() {
      this.clearCountdownTimer();
      this.countDownNum = 5;

      this.timer = setInterval(() => {
        this.countDownNum--;
        if (this.countDownNum <= 0) {
          this.clearCountdownTimer();
        }
      }, 1000);
    },

    clearCountdownTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
  },
};
</script>

<style lang="less" scoped>
// --------------------------------------------------
// 变量定义
// --------------------------------------------------
@gold-primary: #efd498;
@pink-text-stroke: #f05c7d;
@pink-shadow: rgba(226, 77, 112, 0.55);

.major-structure {
  position: relative;
  display: flex;
  justify-content: center;
  user-select: none;

  .bg-img {
    display: block;
    max-width: 100%;
    height: auto;
  }

  .content-wrapper {
    position: absolute;
    top: 85px;
    left: 50%;
    transform: translateX(-50%);
    width: 85%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .header-title {
      width: 100%;
      text-align: center;
      margin-bottom: 10px;

      img {
        max-width: 100%;
        height: auto;
      }
    }

    .detailed-info {
      width: 95%;
      margin: 0 auto;

      .info-block {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
      }
    }
  }
}

// --------------------------------------------------
// 表单输入项样式
// --------------------------------------------------
.input-group {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 180px;
  font-size: 22px;
  color: #ffffff;
  font-weight: 600;

  .label {
    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  }

  input[type="text"] {
    width: 220px;
    height: 36px;
    padding: 0 8px;
    font-size: 22px;
    font-weight: 700;
    color: #ffffff;
    background: transparent;
    border: none;
    border-bottom: 2px solid rgba(255, 255, 255, 0.4);
    outline: none;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    text-align: center;
    text-shadow:
      -1px -1px 0 @pink-text-stroke,
      1px -1px 0 @pink-text-stroke,
      -1px 1px 0 @pink-text-stroke,
      1px 1px 0 @pink-text-stroke,
      0 2px 5px @pink-shadow;

    &::placeholder {
      color: rgba(255, 255, 255, 0.5);
      font-size: 16px;
      font-weight: normal;
      text-shadow: none;
    }

    &:focus {
      border-bottom-color: #ffffff;
      box-shadow: 0 2px 8px rgba(255, 255, 255, 0.3);
    }
  }
}

// --------------------------------------------------
// 提示文字与二次确认
// --------------------------------------------------
.dialog-hint {
  height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #ffffff;
  font-weight: 700;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.6);
  margin: 0;

  &.exchange-hint {
    height: 140px;
  }
}

// --------------------------------------------------
// 按钮系统
// --------------------------------------------------
.action-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 10px;

  &.img-actions {
    .btn-img {
      cursor: pointer;
      transition: transform 0.2s ease, filter 0.2s ease;

      &:hover {
        transform: scale(1.05);
        filter: brightness(1.1);
      }

      &:active {
        transform: scale(0.98);
      }
    }
  }
}

// 通用拟态粉金按钮
.btn-primary,
.btn-secondary {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 150px;
  height: 52px;
  padding: 0 28px;
  border-radius: 26px;
  font-size: 19px;
  font-weight: 800;
  color: #ffffff;
  border: none;
  cursor: pointer;
  outline: none;
  user-select: none;
  transition: all 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);
  background: linear-gradient(180deg, #ffeef3 0%, #ffdce5 45%, #ffcbd8 100%);
  box-shadow:
    0 0 0 2px #fff2f5 inset,
    0 0 0 5px #f78ba8 inset,
    0 0 0 8px #ffdce5 inset,
    0 5px 12px rgba(196, 113, 105, 0.35);
  text-shadow:
    -1px -1px 0 @pink-text-stroke,
    1px -1px 0 @pink-text-stroke,
    -1px 1px 0 @pink-text-stroke,
    1px 1px 0 @pink-text-stroke,
    0 2px 0 #e95778,
    0 3px 5px @pink-shadow;

  &:hover:not(.btn-disabled) {
    transform: translateY(-2px);
    box-shadow:
      0 0 0 2px #fff2f5 inset,
      0 0 0 5px #f78ba8 inset,
      0 0 0 8px #ffdce5 inset,
      0 8px 16px rgba(196, 113, 105, 0.45);
  }

  &:active:not(.btn-disabled) {
    transform: translateY(1px);
    box-shadow:
      0 0 0 2px #fff2f5 inset,
      0 0 0 5px #f78ba8 inset,
      0 0 0 8px #ffdce5 inset,
      0 2px 6px rgba(196, 113, 105, 0.3);
  }
}

// 禁用状态（倒计时）
.btn-disabled {
  cursor: not-allowed;
  filter: grayscale(0.8);
  opacity: 0.85;
}

// --------------------------------------------------
// 规则说明板 & 自定义滚动条
// --------------------------------------------------
.rules-container {
  width: 100%;
  max-height: 270px;
  padding: 15px 20px;
  box-sizing: border-box;
  overflow-y: auto;
  overflow-x: hidden;

  // 自定义极简暗系滚动条
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.15);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(239, 212, 152, 0.5);
    border-radius: 3px;

    &:hover {
      background: rgba(239, 212, 152, 0.8);
    }
  }

  .rule-title {
    font-size: 19px;
    font-weight: 700;
    color: #ffffff;
    margin-top: 14px;
    margin-bottom: 6px;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
  }

  .rule-item {
    font-size: 15px;
    line-height: 1.6;
    color: @gold-primary;
    margin-bottom: 6px;

    &.indent {
      padding-left: 1.2em;
    }

    &.highlight-box {
      background: rgba(0, 0, 0, 0.2);
      padding: 6px 12px;
      border-radius: 4px;
      margin-bottom: 10px;
    }
  }

  .text-center {
    text-align: center;
  }

  .text-danger {
    color: #ff5252;
  }

  .font-bold {
    font-weight: 700;
  }

  .label-gold {
    color: #ffe082;
  }
}
</style>